// import * as angular from "angular";

export function IamRequestsFactory(injector: any) {
  return injector.get('IamRequests');
}

// export const IamRequestsProvider: any = {
//   deps: ['$injector'],
//   provide: 'IamRequests',
//   useFactory: IamRequestsFactory
// };

export function firebaseServiceFactory(injector: any) {
  return injector.get('firebaseService');
}

export const firebaseServiceProvider: any = {
  deps: ['$injector'],
  provide: 'firebaseService',
  useFactory: firebaseServiceFactory
};

export function $stateServiceFactory(injector: any) {
  return injector.get('$state');
}

export const $stateServiceProvider: any = {
  deps: ['$injector'],
  provide: '$state',
  useFactory: $stateServiceFactory
};

export function $windowServiceFactory(injector: any) {
  return injector.get('$window');
}

export const $windowServiceProvider: any = {
  deps: ['$injector'],
  provide: '$window',
  useFactory: $windowServiceFactory
};

export function stateServiceFactory(injector: any) {
  return injector.get('stateService');
}

export const stateServiceProvider: any = {
  deps: ['$injector'],
  provide: 'stateService',
  useFactory: stateServiceFactory
};

export function satellizerConfigFactory(injector: any) {
  return injector.get('SatellizerConfig');
}

export const satellizerConfigProvider: any = {
  deps: ['$injector'],
  provide: 'SatellizerConfig',
  useFactory: satellizerConfigFactory
};


export function splitServiceFactory(injector: any) {
  return injector.get('splitService');
}

export const splitServiceProvider: any = {
  deps: ['$injector'],
  provide: 'splitService',
  useFactory: splitServiceFactory
};

export const planningCommonServiceProvider: any = {
  deps: ['$injector'],
  provide: 'planningCommonService',
  useFactory: (injector) => {
    return injector.get('planningCommonService');
  }
};

export function bringozToastServiceFactory(injector: any) {
  return injector.get('bringozToastService');
}

export const bringozToastServiceProvider: any = {
  deps: ['$injector'],
  provide: 'bringozToastService',
  useFactory: bringozToastServiceFactory
};

export function $timeoutServiceFactory(injector: any) {
  return injector.get('$timeout');
}

export const $timeoutServiceProvider: any = {
  deps: ['$injector'],
  provide: '$timeout',
  useFactory: $timeoutServiceFactory
};

export function deliveriesDialogServiceFactory(injector: any) {
  return injector.get('deliveriesDialogService');
}

export const deliveriesDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'deliveriesDialogService',
  useFactory: deliveriesDialogServiceFactory
};

export function deliveriesServiceFactory(injector: any) {
  return injector.get('deliveriesService');
}

export const deliveriesServiceProvider: any = {
  deps: ['$injector'],
  provide: 'deliveriesService',
  useFactory: deliveriesServiceFactory
};

export function routesServiceFactory(injector: any) {
  return injector.get('routesService');
}

export const routesServiceProvider: any = {
  deps: ['$injector'],
  provide: 'routesService',
  useFactory: routesServiceFactory
};

export function $mdDialogFactory(injector: any) {
  return injector.get('$mdDialog');
}

export const $mdDialogProvider: any = {
  deps: ['$injector'],
  provide: '$mdDialog',
  useFactory: $mdDialogFactory
};

export function commonsServiceFactory(injector: any) {
  return injector.get('commonsService');
}

export const commonsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'commonsService',
  useFactory: commonsServiceFactory
};


export function DeliveriesApiActionFactory(injector: any) {
  return injector.get('DeliveriesApiAction');
}

export const DeliveriesApiActionProvider: any = {
  deps: ['$injector'],
  provide: 'DeliveriesApiAction',
  useFactory: DeliveriesApiActionFactory
};

export function printerServiceFactory(injector: any) {
  return injector.get('printerService');
}

export const printerServiceProvider: any = {
  deps: ['$injector'],
  provide: 'printerService',
  useFactory: printerServiceFactory
};

export function servicesServiceFactory(injector: any) {
  return injector.get('servicesService');
}

export const servicesServiceProvider: any = {
  deps: ['$injector'],
  provide: 'servicesService',
  useFactory: servicesServiceFactory
};

export function commonsDialogServiceFactory(injector: any) {
  return injector.get('commonsDialogService');
}

export const commonsDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'commonsDialogService',
  useFactory: commonsDialogServiceFactory
};

export function expensesDialogServiceFactory(injector: any) {
  return injector.get('expensesDialogService');
}

export const expensesDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'expensesDialogService',
  useFactory: expensesDialogServiceFactory
};

export function expensesServiceFactory(injector: any) {
  return injector.get('expensesService');
}

export const expensesServiceProvider: any = {
  deps: ['$injector'],
  provide: 'expensesService',
  useFactory: expensesServiceFactory
};

export function fulfillmentServiceFactory(injector: any) {
  return injector.get('fulfillmentService');
}

export const fulfillmentServiceProvider: any = {
  deps: ['$injector'],
  provide: 'fulfillmentService',
  useFactory: fulfillmentServiceFactory
};

export function dashboardsServiceFactory(injector: any) {
  return injector.get('dashboardsServiceService');
}

export const dashboardsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'dashboardsServiceService',
  useFactory: dashboardsServiceFactory
};

export function agentDialogServiceFactory(injector: any) {
  return injector.get('agentDialogService');
}

export const agentDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'agentDialogService',
  useFactory: agentDialogServiceFactory
};

export function agentsServiceFactory(injector: any) {
  return injector.get('agentsService');
}

export const agentsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'agentsService',
  useFactory: agentsServiceFactory
};

export function locationServiceFactory(injector: any) {
  return injector.get('locationService');
}

export const locationServiceProvider: any = {
  deps: ['$injector'],
  provide: 'locationService',
  useFactory: locationServiceFactory
};

export function latLngToAddressFactory(injector: any) {
  return injector.get('latLngToAddress');
}

export const latLngToAddressProvider: any = {
  deps: ['$injector'],
  provide: 'latLngToAddress',
  useFactory: latLngToAddressFactory
};

export function pricePlanBundleActionsServiceFactory(injector: any) {
  return injector.get('pricePlanBundleActionsService');
}

export const pricePlanBundleActionsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'pricePlanBundleActionsService',
  useFactory: pricePlanBundleActionsServiceFactory
};

export function pricePlanDialogServiceFactory(injector: any) {
  return injector.get('pricePlanDialogService');
}

export const pricePlanDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'pricePlanDialogService',
  useFactory: pricePlanDialogServiceFactory
};

export function pricePlanBundleServiceFactory(injector: any) {
  return injector.get('pricePlanBundleService');
}

export const pricePlanBundleServiceProvider: any = {
  deps: ['$injector'],
  provide: 'pricePlanBundleService',
  useFactory: pricePlanBundleServiceFactory
};


export function accountDialogServiceFactory(injector: any) {
  return injector.get('accountDialogService');
}

export const accountDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'accountDialogService',
  useFactory: accountDialogServiceFactory
};

export function mapsCommonServiceFactory(injector: any) {
  return injector.get('mapsCommonService');
}

export const mapsCommonServiceProvider: any = {
  deps: ['$injector'],
  provide: 'mapsCommonService',
  useFactory: mapsCommonServiceFactory
};


export function dashboardsDialogsServiceFactory(injector: any) {
  return injector.get('dashboardsDialogsService');
}

export const dashboardsDialogsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'dashboardsDialogsService',
  useFactory: dashboardsDialogsServiceFactory
};

export function planningAlertsServiceFactory(injector: any) {
  return injector.get('planningAlertsService');
}

export const planningAlertsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'planningAlertsService',
  useFactory: planningAlertsServiceFactory
};

export function planningDialogServiceFactory(injector: any) {
  return injector.get('planningDialogService');
}

export const planningDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'planningDialogService',
  useFactory: planningDialogServiceFactory
};

export function schedulingProjectAlertsServiceFactory(injector: any) {
  return injector.get('schedulingProjectAlertsService');
}

export const schedulingProjectAlertsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'schedulingProjectAlertsService',
  useFactory: schedulingProjectAlertsServiceFactory
};

export function $branchesFactory(injector: any) {
  return injector.get('$branches');
}

export const $branchesProvider: any = {
  deps: ['$injector'],
  provide: '$branches',
  useFactory: $branchesFactory
};

export function dateRangeTimeFiltersServiceFactory(injector: any) {
  return injector.get('dateRangeTimeFiltersService');
}

export const dateRangeTimeFiltersServiceProvider: any = {
  deps: ['$injector'],
  provide: 'dateRangeTimeFiltersService',
  useFactory: dateRangeTimeFiltersServiceFactory
};


export function taskRequestsFactory(injector: any) {
  return injector.get('taskRequests');
}

export const taskRequestsProvider: any = {
  deps: ['$injector'],
  provide: 'taskRequests',
  useFactory: taskRequestsFactory
}

export function tasksServiceFactory(injector: any) {
  return injector.get('tasksService');
}

export const tasksServiceProvider: any = {
  deps: ['$injector'],
  provide: 'tasksService',
  useFactory: tasksServiceFactory
}

export function actionReasonsDialogsServiceFactory(injector: any) {
  return injector.get('actionReasonsDialogsService');
}

export const actionReasonsDialogsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'actionReasonsDialogsService',
  useFactory: actionReasonsDialogsServiceFactory
}

export function deliveriesAlertsServiceFactory(injector: any) {
  return injector.get('deliveriesAlertsService');
}

export const deliveriesAlertsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'deliveriesAlertsService',
  useFactory: deliveriesAlertsServiceFactory
}

export function bringozUnitConversionServiceFactory(injector: any) {
  return injector.get('bringozUnitConversionService');
}

export const bringozUnitConversionServiceProvider: any = {
  deps: ['$injector'],
  provide: 'bringozUnitConversionService',
  useFactory: bringozUnitConversionServiceFactory
}

export function viewFilterSettingsServiceFactory(injector: any) {
  return injector.get('viewFilterSettingsService');
}

export const viewFilterSettingsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'viewFilterSettingsService',
  useFactory: viewFilterSettingsServiceFactory
}

export function batchRecoveryServiceFactory(injector: any) {
  return injector.get('batchRecoveryService');
}

export const batchRecoveryServiceProvider: any = {
  deps: ['$injector'],
  provide: 'batchRecoveryService',
  useFactory: batchRecoveryServiceFactory
}

export function reportsDialogServiceFactory(injector: any) {
  return injector.get('reportsDialogService');
}

export const reportsDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'reportsDialogService',
  useFactory: reportsDialogServiceFactory
};

export function reportsRequestsFactory(injector: any) {
  return injector.get('reportsRequests');
}

export const reportsRequestsProvider: any = {
  deps: ['$injector'],
  provide: 'reportsRequests',
  useFactory: reportsRequestsFactory
};

export function leanPlanningServiceFactory(injector: any) {
  return injector.get('leanPlanningService');
}

export const leanPlanningServiceProvider: any = {
  deps: ['$injector'],
  provide: 'leanPlanningService',
  useFactory: leanPlanningServiceFactory
};

export function tagsServiceFactory(injector: any) {
  return injector.get('tagsService');
}

export const tagsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'tagsService',
  useFactory: tagsServiceFactory
};


export function attachmentsServiceFactory(injector: any) {
  return injector.get('attachmentsService');
}

export const attachmentsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'attachmentsService',
  useFactory: attachmentsServiceFactory
};


export function dashboardsAlertsServiceFactory(injector: any) {
  return injector.get('dashboardsAlertsService');
}

export const dashboardsAlertsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'dashboardsAlertsService',
  useFactory: dashboardsAlertsServiceFactory
};


export function UserServiceFactory(injector: any) {
  return injector.get('UserService');
}

export const UserServiceProvider: any = {
  deps: ['$injector'],
  provide: 'UserService',
  useFactory: UserServiceFactory
};

export function viewSettingsServiceFactory(injector: any) {
  return injector.get('viewSettingsService');
}

export const viewSettingsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'viewSettingsService',
  useFactory: viewSettingsServiceFactory
};

export function planningProjectsServiceFactory(injector: any) {
  return injector.get('planningProjectsService');
}

export const planningProjectsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'planningProjectsService',
  useFactory: planningProjectsServiceFactory
};

export function confirmDialogServiceFactory(injector: any) {
  return injector.get('confirmDialogService');
}

export const confirmDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'confirmDialogService',
  useFactory: confirmDialogServiceFactory
};

export function skillsServiceFactory(injector: any) {
  return injector.get('skillsService');
}

export const skillsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'skillsService',
  useFactory: skillsServiceFactory
};

export function agentInventoryDialogServiceFactory(injector: any) {
  return injector.get('agentInventoryDialogService');
}

export const agentInventoryDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'agentInventoryDialogService',
  useFactory: agentInventoryDialogServiceFactory
};

export function agentConfigurationProfilesRequestsServiceFactory(injector: any) {
  return injector.get('agentConfigurationProfilesRequestsService');
}

export const agentConfigurationProfilesRequestsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'agentConfigurationProfilesRequestsService',
  useFactory: agentConfigurationProfilesRequestsServiceFactory
};

export function attendanceRequestsServiceFactory(injector: any) {
  return injector.get('attendanceRequestsService');
}

export const attendanceRequestsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'attendanceRequestsService',
  useFactory: attendanceRequestsServiceFactory
};

export function agentsAlertsFactory(injector: any) {
  return injector.get('agentsAlerts');
}

export const agentsAlertsProvider: any = {
  deps: ['$injector'],
  provide: 'agentsAlerts',
  useFactory: agentsAlertsFactory
};

export function analyticsServiceFactory(injector: any) {
  return injector.get('analyticsService');
}

export const analyticsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'analyticsService',
  useFactory: analyticsServiceFactory
};

export function siteProvidersDialogsServiceFactory(injector: any) {
  return injector.get('siteProvidersDialogsService');
}

export const siteProvidersDialogsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'siteProvidersDialogsService',
  useFactory: siteProvidersDialogsServiceFactory
};

export function bringozLoaderServiceFactory(injector: any) {
  return injector.get('bringozLoaderService');
}

export const bringozLoaderServiceProvider: any = {
  deps: ['$injector'],
  provide: 'bringozLoaderService',
  useFactory: bringozLoaderServiceFactory
};

export function $logFactory(injector: any) {
  return injector.get('$log');
}

export const $logProvider: any = {
  deps: ['$injector'],
  provide: '$log',
  useFactory: $logFactory
};

export function fulfillmentStepRequestsServiceFactory(injector: any) {
  return injector.get('fulfillmentStepRequestsService');
}

export const fulfillmentStepRequestsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'fulfillmentStepRequestsService',
  useFactory: fulfillmentStepRequestsServiceFactory
};

export function fulfillmentDialogServiceFactory(injector: any) {
  return injector.get('fulfillmentDialogService');
}

export const fulfillmentDialogServiceProvider: any = {
  deps: ['$injector'],
  provide: 'fulfillmentDialogService',
  useFactory: fulfillmentDialogServiceFactory
};

export function attachmentsDialogFactory(injector: any) {
  return injector.get('attachmentsDialog');
}

export const attachmentsDialogProvider: any = {
  deps: ['$injector'],
  provide: 'attachmentsDialog',
  useFactory: attachmentsDialogFactory
};

export function dateRangeContextServiceFactory(injector: any) {
  return injector.get('dateRangeContextService');
}

export const dateRangeContextServiceProvider: any = {
  deps: ['$injector'],
  provide: 'dateRangeContextService',
  useFactory: dateRangeContextServiceFactory
};

export function siteContextServiceFactory(injector: any) {
  return injector.get('siteContextService');
}

export const siteContextServiceProvider: any = {
  deps: ['$injector'],
  provide: 'siteContextService',
  useFactory: siteContextServiceFactory
};

export function packageDetailsViewSettingsServiceFactory(injector: any) {
  return injector.get('packageDetailsViewSettingsService');
}

export const packageDetailsViewSettingsServiceProvider: any = {
  deps: ['$injector'],
  provide: 'packageDetailsViewSettingsService',
  useFactory: packageDetailsViewSettingsServiceFactory
};
